import { render, staticRenderFns } from "./KioskDetail.vue?vue&type=template&id=e162771c&"
import script from "./KioskDetail.vue?vue&type=script&lang=js&"
export * from "./KioskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports